import React from "react";
import LegalHeader from "./LegalHeader";
import LegalSidebar from "./LegalSidebar";
import FooterLinks from "../LandingPage/FooterLinks";

export default function LegalPageLayout({ children }) {
  return (
    <div className="relative min-h-screen w-full bg-white">
      <div className="relative z-10 flex flex-col">
        <LegalHeader />

        {/* Banner Image */}
        <div className="w-full bg-white">
          <img
            src="/assets/images/legal.gif"
            alt="About Million2Trillion"
            className="block w-full"
            style={{
              width: "100vw",
              maxWidth: "100vw",
              height: "auto",
            }}
            draggable={false}
          />
        </div>

        {/* Responsive: flex-col on mobile, flex-row on desktop */}
        <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-0 px-2 py-36 md:flex-row md:gap-10 md:px-6">
          <LegalSidebar />
          <main className="-mt-10 mb-24 min-w-0 flex-1 rounded-xl bg-white px-0 py-2 md:px-10 md:py-0">
            {children}
          </main>
        </div>

        <div className="mb-0 mt-8 bg-black">
          <FooterLinks />
        </div>
      </div>
    </div>
  );
}
